module.exports = __webpack_public_path__ + "img/customs.a243c33d.svg";